import React, { useEffect, useState } from "react";
import { Container } from "./styled";
import { calculatePercj, calculatePlayerStats } from "../../lib/cabbStats";

export default function PlayerStatsTable({
  activeGames,
  activeProfile,
  activeProfileId,
  activeSeason,
  isDnD,
  players,
  setActiveProfile,
  activePhase,
  activeHistoryTeam,
}) {
  let gamesPlayed = calculatePlayerStats(
    activeGames,
    activeProfile?._id,
    "GAMES"
  );

  const getGamesScore = () => {
    let wonGames = 0;
    const filteredGames = activeGames?.filter(
      (game) =>
        (game.local_team === activeHistoryTeam ||
          game.visit_team === activeHistoryTeam) &&
        game.season === activeSeason &&
        (activePhase === undefined ||
          activePhase === null ||
          game.stage === activePhase)
    );

    const teamsInSeason = activeProfile?.teams_history
      .filter((item) => item.season === activeSeason)
      .map((item) => item.teamId);

    for (let index = 0; index < filteredGames?.length; index++) {
      let localTotalPts = 0;
      let visitTotalPts = 0;
      const game = filteredGames[index];

      // Verificar si el jugador jugó en el equipo local
      if (teamsInSeason.includes(game.local_team)) {
        const playerStats = game.local_stats.find(
          (player) => player.player_id === activeProfile?._id
        );

        let minutos = playerStats?.mins?.replace(":", ".") || "0";
        if (Number(minutos) > 0) {
          game.local_stats.forEach((element) => {
            localTotalPts += element.pts;
          });
          game.visit_stats.forEach((element) => {
            visitTotalPts += element.pts;
          });
          if (localTotalPts > visitTotalPts) {
            wonGames++;
          }
        }

        // Verificar si el jugador jugó en el equipo visitante
      } else if (teamsInSeason.includes(game.visit_team)) {
        const playerStats = game.visit_stats.find(
          (player) => player.player_id === activeProfile?._id
        );

        let minutos = playerStats?.mins?.replace(":", ".") || "0";
        if (Number(minutos) > 0) {
          game.local_stats.forEach((element) => {
            localTotalPts += element.pts;
          });
          game.visit_stats.forEach((element) => {
            visitTotalPts += element.pts;
          });
          if (visitTotalPts > localTotalPts) {
            wonGames++;
          }
        }
      }
    }

    return wonGames;
  };
  let gamesWon = getGamesScore();

  let pie = (
    ((Number(calculatePlayerStats(activeGames, activeProfileId, "PTSTot")) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "FGTot")) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "FTTot")) -
      Number(calculatePlayerStats(activeGames, activeProfileId, "FGATot")) -
      Number(calculatePlayerStats(activeGames, activeProfileId, "FTATot")) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "DRBTot")) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "ORBTot") / 2) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "ASSTot")) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "STLTot")) +
      Number(calculatePlayerStats(activeGames, activeProfileId, "BLKTot")) / 2 -
      Number(calculatePlayerStats(activeGames, activeProfileId, "FLTot")) -
      Number(calculatePlayerStats(activeGames, activeProfileId, "TORTot"))) /
      (calculatePercj(
        activeGames,
        activeProfile?.teams_history.find(
          (item) => item.season === activeSeason
        )?.teamId,
        "PTSTot"
      ) +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "FGTot"
        ) +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "FTTot"
        ) -
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "FGATot"
        ) -
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "FTATot"
        ) +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "DRBTot"
        ) +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "ORBTot"
        ) /
          2 +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "ASSTot"
        ) +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "STLTot"
        ) +
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "BLKTot"
        ) /
          2 -
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "PFTot"
        ) -
        calculatePercj(
          activeGames,
          activeProfile?.teams_history.find(
            (item) => item.season === activeSeason
          )?.teamId,
          "TORTot"
        ))) *
    100
  ).toFixed(1);

  return (
    <Container isDnD={isDnD}>
      {isDnD ? (
        <select onChange={(e) => setActiveProfile(e.target.value)}>
          <option value="">Selecciona jugador</option>
          {players !== null &&
            players !== undefined &&
            players
              .filter((player) => player.active_team !== "undefined")
              .sort((a, b) => {
                const fullNameA = `${a.player_name
                  ?.toUpperCase()
                  .trimStart()} ${a.player_lastname
                  ?.toUpperCase()
                  .trimStart()}`;
                const fullNameB = `${b.player_name
                  ?.toUpperCase()
                  .trimStart()} ${b.player_lastname
                  ?.toUpperCase()
                  .trimStart()}`;
                return fullNameA.localeCompare(fullNameB);
              })
              .map((player, index) => (
                <option value={player._id}>
                  {`${player.player_name
                    ?.toUpperCase()
                    .trimStart()} ${player.player_lastname
                    ?.toUpperCase()
                    .trimStart()}`}
                </option>
              ))}
        </select>
      ) : null}
      <div className="player-stats-table">
        <div className="matches-container">
          <div>
            <h2>{gamesPlayed}</h2>
            <p>Partidos</p>
          </div>
          <div
            class="circle-border"
            style={{
              background: `linear-gradient(270deg, red ${
                (gamesWon / gamesPlayed) * 100
              }%, transparent 50%)`,
            }}
          >
            <div class="circle">
              <p>
                {isNaN(Math.round((gamesWon / gamesPlayed) * 100))
                  ? 0
                  : Math.round((gamesWon / gamesPlayed) * 100)}
              </p>
            </div>
            <div className="hover-information">
              <p>Porcentaje de victorias</p>
            </div>
          </div>
        </div>
        <div className="stats-table-header">Estadisticas</div>
        <div className="stats-table-content">
          <div className="data-object">
            <p className="data-title">MPP</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "MINSP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">USG</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "USG")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">+/-</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "VAL")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">PTS</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "PTS")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FG</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "FG")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FG%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "FGP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FT</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "FT")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FT%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "FTP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">2P</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "TWOOP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">2P%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "TWOOPP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">3P</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "THREEP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">3P%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "THREEPP")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">ASI</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "ASS")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">ROB</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "STL")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">TAP</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "BLK")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FUL</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "FL")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">ORB</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "ORB")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">DRB</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "DRB")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">TUR</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "TO")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">PIE%</p>
            <p className="data-value">{pie}</p>
          </div>
        </div>
        <div className="stats-table-footer">
          <p className="title">Cuatro factores ofensivos</p>
          <div className="data-object">
            <p className="data-title">EFG%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "eFG")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">TOR%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "TOR")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">OREB%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "OREB")}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FTR%</p>
            <p className="data-value">
              {calculatePlayerStats(activeGames, activeProfileId, "FTR")}
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
}
